import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
interface InsightCardProps {
  insight: string;
  actionLink?: string;
  actionText?: string;
}
export function InsightCard({
  insight,
  actionLink = '/blog',
  actionText = 'Read More'
}: InsightCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="relative w-full max-w-3xl mx-auto mt-16 group" data-id="element-1154">
      {/* Glow Effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 via-red-500 to-purple-600 rounded-[2rem] blur-xl opacity-40 group-hover:opacity-60 transition-opacity duration-700 animate-pulse" data-id="element-1155" />

      <div className="relative bg-gray-950 rounded-[1.8rem] p-8 md:p-12 text-center border border-white/10 overflow-hidden" data-id="element-1156">
        {/* Background Texture */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay pointer-events-none" data-id="element-1157"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-1158"></div>

        {/* Icon */}
        <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-400 to-red-600 mb-8 shadow-xl shadow-red-500/20 group-hover:scale-110 transition-transform duration-500" data-id="element-1159">
          <div className="absolute inset-0 bg-white/20 rounded-2xl backdrop-blur-sm" data-id="element-1160" />
          <Lightbulb className="w-10 h-10 text-white relative z-10" strokeWidth={2.5} data-id="element-1161" />
          <Sparkles className="absolute -top-2 -right-2 text-yellow-200 w-6 h-6 animate-bounce" data-id="element-1162" />
        </div>

        <h3 className="text-sm font-bold text-amber-400 uppercase tracking-widest mb-6" data-id="element-1163">
          Key Takeaway
        </h3>

        <p className="text-2xl md:text-3xl font-medium text-white leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-1164">
          "{insight}"
        </p>

        <Link to={actionLink} className="inline-flex items-center gap-3 px-8 py-4 bg-white text-gray-950 rounded-full font-bold text-lg hover:bg-gray-100 transition-all hover:scale-105 hover:shadow-xl hover:shadow-white/10 group/btn" data-id="element-1165">
          {actionText}
          <ArrowRight size={20} className="group-hover/btn:translate-x-1 transition-transform" data-id="element-1166" />
        </Link>
      </div>
    </motion.div>;
}